<template>
    <div>
        <a class="p-2 mr-2 text-teal-600 hover:text-teal-500" href="#" @click.stop.prevent="openModal">
            <i class="fa fa-pencil"></i>
            <span class="hidden sm:inline-block">Edit</span>
        </a>

        <Modal
            v-if="showModal"
            :modal-title="modalTitle"
            close-confirm-message="You will loose all the data you have entered so far, are you sure?"
            @close="closeModal"
        >
            <template v-slot:body>
                <WorkExperienceForm v-if="model === 'work-experience'" ref="form" :user-id="userId" :update-rec="record" />
                <EducationForm v-if="model === 'education'" ref="form" :user-id="userId" :update-rec="record" />
                <CertificationForm v-if="model === 'certification'" ref="form" :user-id="userId" :update-rec="record" />
                <ServiceForm v-if="model === 'service'" ref="form" :update-rec="record" />
                <ProfileProjectForm v-if="model === 'project'" ref="form" :update-rec="record" />
            </template>
            <template v-slot:footer>
                <my-button :loading="submitting" class="btn btn-primary float-right" @click="submitForm">
                    <i class="fa fa-save"></i> Update Details
                </my-button>
            </template>
        </Modal>
    </div>
</template>

<script>
import Modal from '../Modal';
import WorkExperienceForm from '../WorkExperience/WorkExperienceForm';
import EducationForm from '../Education/EducationForm';
import CertificationForm from '../Certification/CertificationForm';
import ServiceForm from '../Service/ServiceForm';
import ProfileProjectForm from '../ProfileProject/ProfileProjectForm';

export default {
    components: {
        Modal,
        WorkExperienceForm,
        EducationForm,
        CertificationForm,
        ServiceForm,
        ProfileProjectForm
    },

    props: {
        userId: {
            type: String,
            default: null
        },
        record: {
            type: Object,
            required: true
        },
        modalTitle: {
            type: String,
            required: true
        },
        model: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            showModal: false,
            submitting: false
        };
    },

    methods: {
        openModal() {
            this.showModal = true;
        },

        closeModal() {
            this.showModal = false;
        },

        submitForm() {
            this.submitting = true;

            this.$refs.form
                .submit()
                .then(() => {
                    this.$emit('updated');
                    this.closeModal();
                    flash.success();
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        flash.error({ message: 'It seems like you have submitted invalid data.' });
                        return;
                    }

                    flash.error();
                })
                .then(() => {
                    this.submitting = false;
                });
        }
    }
};
</script>
